import { CircularProgress } from '@mui/material';

const Loader = () => <CircularProgress color="primary" />;

export default Loader;
